import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M.5 9h5.691l1.861-3.724c.09-.181.286-.288.482-.275.202.014.375.148.439.34l2.568 7.705 1.493-3.732c.076-.19.26-.314.464-.314h6c.276 0 .5.224.5.5s-.224.5-.5.5h-5.662l-1.874 4.686c-.076.19-.26.314-.464.314h-.015c-.21-.007-.394-.143-.459-.342L8.405 6.803l-1.46 2.92a.5008.5008 0 0 1-.447.276h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5z',
    'M2.5 7c.276 0 .5-.224.5-.5V4c0-.551.449-1 1-1h12c.551 0 1 .449 1 1v2.5c0 .276.224.5.5.5s.5-.224.5-.5V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v2.5c0 .276.224.5.5.5zM17.5 12c-.276 0-.5.224-.5.5V16c0 .551-.449 1-1 1H4c-.551 0-1-.449-1-1v-3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5V16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3.5c0-.276-.224-.5-.5-.5z',
  ],
  height: 20,
  width: 20,
});
